export const AUTH_USER_LIST_REQUEST = 'AUTH_USER_LIST_REQUEST'
export const AUTH_USER_LIST_SUCCESS = 'AUTH_USER_LIST_SUCCESS'
export const AUTH_USER_LIST_FAIL = 'AUTH_USER_LIST_FAIL'
export const AUTH_USER_LIST_RESET = 'AUTH_USER_LIST_RESET'
